import { ByocUploadContentService } from './../../service/upload-content.service';
import { ByocEpisodeService } from './../../service/episode.service';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { control } from '../../../utils';

@Component({
    selector: 'app-byoc-episode-step-upload-document',
    templateUrl: './upload-document.component.html',
    styleUrls: ['./upload-document.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ByocEpisodeStepUploadDocumentComponent {
    private byocEpisodeService = inject(ByocEpisodeService);
    private uploadContentService = inject(ByocUploadContentService);

    get termsAcceptControl() {
        return control(this.byocEpisodeService.form.get('hostedCustomContent')!.get('termsAccept'));
    }

    get documentControl() {
        return this.uploadContentService.fileControl;
    }

    get hasFile() {
        return this.documentControl.value?.file !== null;
    }

    get hasAcceptTerms() {
        return this.termsAcceptControl.value;
    }

    next() {
        if (this.hasAcceptTerms) {
            this.uploadContentService.uploadDocumentGoToGeneralStepFrom();
        }
    }

    cancel() {
        this.byocEpisodeService.close('btn-close');
    }
}
